export const ELEMENT_FAMILIES = {
    de: [
        'Alkali Metalle',
        'Erdalkalimetalle',
        'Übergangsserie',
        'Post-Transition-Serie',
        'Nichtmetalle',
        'Non-metals',
        'Edelgase',
        'Lanthanoide',
        'Aktiniden'
    ],
    en: [
        'Alkali metals',
        'Alkaline earth metals',
        'Transition series',
        'Post-transition series',
        'Metalloids',
        'Non-metals',
        'Noble gases',
        'Lanthanides',
        'Actinides'
    ],
    es: [
        'Metales alcalinos',
        'Metales alcalinotérreos',
        'Serie de transición',
        'Serie posterior a la transición',
        'Metaloides',
        'No-metales',
        'Gases nobles',
        'Lantánidos',
        'Actínidos'
    ],
    fr: [
        'Métaux alcalins',
        'Métaux alcalino-terreux',
        'Série Transitions',
        'Série Post-Transition',
        'Métalloïdes',
        'Non-métaux',
        'Gaz nobles',
        'Lanthanides',
        'Actinides'
    ],
    it: [
        'Metalli alcalini',
        'Metalli alcalino-terrosi',
        'Serie di transizione',
        "Serie post-transizione",
        'Metalloidi',
        'Non-metalli',
        'Gas nobili',
        'Lantanidi',
        'Attinidi'
    ],
    ru: [
        'Щелочные металлы',
        'Щелочноземельные металлы',
        'Переходная серия',
        'Постпереходная серия',
        'Металлоиды',
        'Неметаллы',
        'благородные газы',
        'Лантаниды',
        'Актиниды'
    ]
};

export const ELEMENTS = {
    de: [
        { family: 0, symbol: 'Li', label: 'Lithium' },
        { family: 0, symbol: 'Na', label: 'Natrium' },
        { family: 0, symbol: 'K', label: 'Kalium' },
        { family: 0, symbol: 'Rb', label: 'Rubidium' },
        { family: 0, symbol: 'Cs', label: 'Cäsium' },
        { family: 0, symbol: 'Fr', label: 'Francium' },
        { family: 1, symbol: 'Be', label: 'Beryllium' },
        { family: 1, symbol: 'Mg', label: 'Magnesium' },
        { family: 1, symbol: 'Ca', label: 'Kalzium' },
        { family: 1, symbol: 'Sr', label: 'Strontium' },
        { family: 1, symbol: 'Ba', label: 'Barium' },
        { family: 1, symbol: 'Ra', label: 'Radium' },
        { family: 2, symbol: 'Sc', label: 'Scandium'},
        { family: 2, symbol: 'Ti', label: 'Titan'},
        { family: 2, symbol: 'V', label: 'Vanadium'},
        { family: 2, symbol: 'Cr', label: 'Chrom'},
        { family: 2, symbol: 'Mn', label: 'Mangan'},
        { family: 2, symbol: 'Fe', label: 'Eisen'},
        { family: 2, symbol: 'Co', label: 'Kobalt'},
        { family: 2, symbol: 'Ni', label: 'Nickel'},
        { family: 2, symbol: 'Cu', label: 'Kupfer'},
        { family: 2, symbol: 'Zn', label: 'Zink'},
        { family: 2, symbol: 'Y', label: 'Yttrium'},
        { family: 2, symbol: 'Zr', label: 'Zirkonium'},
        { family: 2, symbol: 'Nb', label: 'Niob'},
        { family: 2, symbol: 'Mo', label: 'Molybdän'},
        { family: 2, symbol: 'Tc', label: 'Technetium'},
        { family: 2, symbol: 'Ru', label: 'Ruthenium'},
        { family: 2, symbol: 'Rh', label: 'Rhodium'},
        { family: 2, symbol: 'Pd', label: 'Palladium'},
        { family: 2, symbol: 'Ag', label: 'Silber'},
        { family: 2, symbol: 'Cd', label: 'Cadmium'},
        { family: 2, symbol: 'La', label: 'Lanthan'},
        { family: 2, symbol: 'Hf', label: 'Hafnium'},
        { family: 2, symbol: 'Ta', label: 'Tantal'},
        { family: 2, symbol: 'W', label: 'Wolfram'},
        { family: 2, symbol: 'Re', label: 'Rhenium'},
        { family: 2, symbol: 'Os', label: 'Osmium'},
        { family: 2, symbol: 'Ir', label: 'Iridium'},
        { family: 2, symbol: 'Pt', label: 'Platin'},
        { family: 2, symbol: 'Au', label: 'Gold'},
        { family: 2, symbol: 'Hg', label: 'Quecksilber'},
        { family: 2, symbol: 'Ac', label: 'Aktinium'},
        { family: 2, symbol: 'Rf', label: 'Rutherfordium'},
        { family: 2, symbol: 'Db', label: 'Dubnium'},
        { family: 2, symbol: 'Sg', label: 'Seaborgium'},
        { family: 2, symbol: 'Bh', label: 'Bohrium'},
        { family: 2, symbol: 'Hs', label: 'Hassium'},
        { family: 2, symbol: 'Mt', label: 'Meitnerium'},
        { family: 2, symbol: 'Ds', label: 'Darmstadtium'},
        { family: 2, symbol: 'Rg', label: 'Röntgen'},
        { family: 2, symbol: 'Cn', label: 'Kopernikium'},
        { family: 3, symbol: 'Al', label: 'Aluminium'},
        { family: 3, symbol: 'Ga', label: 'Gallium'},
        { family: 3, symbol: 'In', label: 'Indium'},
        { family: 3, symbol: 'Sn', label: 'Zinn'},
        { family: 3, symbol: 'Tl', label: 'Thallium'},
        { family: 3, symbol: 'Pb', label: 'Führen'},
        { family: 3, symbol: 'Bi', label: 'Wismut'},
        { family: 3, symbol: 'Nh', label: 'Nihonium'},
        { family: 3, symbol: 'Fl', label: 'Flerovium'},
        { family: 3, symbol: 'Mc', label: 'Moscovium'},
        { family: 3, symbol: 'Lv', label: 'Livermorium'},
        { family: 4, symbol: 'B', label: 'Bor'},
        { family: 4, symbol: 'Si', label: 'Silizium'},
        { family: 4, symbol: 'Ge', label: 'Germanium'},
        { family: 4, symbol: 'As', label: 'Arsen'},
        { family: 4, symbol: 'Sb', label: 'Antimon'},
        { family: 4, symbol: 'Te', label: 'Tellur'},
        { family: 4, symbol: 'Po', label: 'Polonium'},
        { family: 5, symbol: 'H', label: 'Wasserstoff' },
        { family: 5, symbol: 'C', label: 'Kohlenstoff' },
        { family: 5, symbol: 'N', label: 'Stickstoff' },
        { family: 5, symbol: 'O', label: 'Sauerstoff' },
        { family: 5, symbol: 'F', label: 'Fluor' },
        { family: 5, symbol: 'P', label: 'Phosphor' },
        { family: 5, symbol: 'S', label: 'Schwefel' },
        { family: 5, symbol: 'Cl', label: 'Chlor'},
        { family: 5, symbol: 'Se', label: 'Selen'},
        { family: 5, symbol: 'Br', label: 'Brom'},
        { family: 5, symbol: 'I', label: 'Iod'},
        { family: 5, symbol: 'At', label: 'Astat'},
        { family: 5, symbol: 'Ts', label: 'Tenness'},
        { family: 6, symbol: 'He', label: 'Helium'},
        { family: 6, symbol: 'Ne', label: 'Neon'},
        { family: 6, symbol: 'Ar', label: 'Argon'},
        { family: 6, symbol: 'Kr', label: 'Krypton'},
        { family: 6, symbol: 'Xe', label: 'Xenon'},
        { family: 6, symbol: 'Rn', label: 'Radon'},
        { family: 6, symbol: 'Og', label: 'Oganesson'},
        { family: 7, symbol: 'Ce', label: 'Cer' },
        { family: 7, symbol: 'Pr', label: 'Praseodym' },
        { family: 7, symbol: 'Nd', label: 'Neodym' },
        { family: 7, symbol: 'Pm', label: 'Promethium' },
        { family: 7, symbol: 'Sm', label: 'Samarium' },
        { family: 7, symbol: 'Eu', label: 'Europium' },
        { family: 7, symbol: 'Gd', label: 'Gadolinium' },
        { family: 7, symbol: 'Tb', label: 'Terbium' },
        { family: 7, symbol: 'Dy', label: 'Dysprosium' },
        { family: 7, symbol: 'Ho', label: 'Holmium' },
        { family: 7, symbol: 'Er', label: 'Erbium' },
        { family: 7, symbol: 'Tm', label: 'Thulium' },
        { family: 7, symbol: 'Yb', label: 'Ytterbium' },
        { family: 7, symbol: 'Lu', label: 'Lutetium' },
        { family: 8, symbol: 'Th', label: 'Thorium' },
        { family: 8, symbol: 'Pa', label: 'Protaktinium' },
        { family: 8, symbol: 'U', label: 'Uran' },
        { family: 8, symbol: 'Np', label: 'Neptunium' },
        { family: 8, symbol: 'Pu', label: 'Plutonium' },
        { family: 8, symbol: 'Am', label: 'Americium' },
        { family: 8, symbol: 'Cm', label: 'Curium' },
        { family: 8, symbol: 'Bk', label: 'Berkellium' },
        { family: 8, symbol: 'Cf', label: 'Kalifornien' },
        { family: 8, symbol: 'Es', label: 'Einsteinium' },
        { family: 8, symbol: 'Fm', label: 'Fermium' },
        { family: 8, symbol: 'Md', label: 'Mendelevium' },
        { family: 8, symbol: 'No', label: 'Nobelium' },
        { family: 8, symbol: 'Lr', label: 'Lawrencium' }
    ],
    en: [
        { family: 0, symbol: 'Li', label: 'Lithium' },
        { family: 0, symbol: 'Na', label: 'Sodium' },
        { family: 0, symbol: 'K', label: 'Potassium' },
        { family: 0, symbol: 'Rb', label: 'Rubidium' },
        { family: 0, symbol: 'Cs', label: 'Cesium' },
        { family: 0, symbol: 'Fr', label: 'Francium' },
        { family: 1, symbol: 'Be', label: 'Beryllium' },
        { family: 1, symbol: 'Mg', label: 'Magnesium' },
        { family: 1, symbol: 'Ca', label: 'Calcium' },
        { family: 1, symbol: 'Sr', label: 'Strontium' },
        { family: 1, symbol: 'Ba', label: 'Barium' },
        { family: 1, symbol: 'Ra', label: 'Radium' },
        { family: 2, symbol: 'Sc', label: 'Scandium'},
        { family: 2, symbol: 'Ti', label: 'Titanium'},
        { family: 2, symbol: 'V', label: 'Vanadium'},
        { family: 2, symbol: 'Cr', label: 'Chromium'},
        { family: 2, symbol: 'Mn', label: 'Manganese'},
        { family: 2, symbol: 'Fe', label: 'Iron'},
        { family: 2, symbol: 'Co', label: 'Cobalt'},
        { family: 2, symbol: 'Ni', label: 'Nickel'},
        { family: 2, symbol: 'Cu', label: 'Copper'},
        { family: 2, symbol: 'Zn', label: 'Zinc'},
        { family: 2, symbol: 'Y', label: 'Yttrium'},
        { family: 2, symbol: 'Zr', label: 'Zirconium'},
        { family: 2, symbol: 'Nb', label: 'Niobium'},
        { family: 2, symbol: 'Mo', label: 'Molybdenum'},
        { family: 2, symbol: 'Tc', label: 'Technetium'},
        { family: 2, symbol: 'Ru', label: 'Ruthenium'},
        { family: 2, symbol: 'Rh', label: 'Rhodium'},
        { family: 2, symbol: 'Pd', label: 'Palladium'},
        { family: 2, symbol: 'Ag', label: 'Silver'},
        { family: 2, symbol: 'Cd', label: 'Cadmium'},
        { family: 2, symbol: 'La', label: 'Lanthanum'},
        { family: 2, symbol: 'Hf', label: 'Hafnium'},
        { family: 2, symbol: 'Ta', label: 'Tantalum'},
        { family: 2, symbol: 'W', label: 'Tungsten'},
        { family: 2, symbol: 'Re', label: 'Rhenium'},
        { family: 2, symbol: 'Os', label: 'Osmium'},
        { family: 2, symbol: 'Ir', label: 'Iridium'},
        { family: 2, symbol: 'Pt', label: 'Platinum'},
        { family: 2, symbol: 'Au', label: 'Gold'},
        { family: 2, symbol: 'Hg', label: 'Mercury'},
        { family: 2, symbol: 'Ac', label: 'Actinium'},
        { family: 2, symbol: 'Rf', label: 'Rutherfordium'},
        { family: 2, symbol: 'Db', label: 'Dubnium'},
        { family: 2, symbol: 'Sg', label: 'Seaborgium'},
        { family: 2, symbol: 'Bh', label: 'Bohrium'},
        { family: 2, symbol: 'Hs', label: 'Hassium'},
        { family: 2, symbol: 'Mt', label: 'Meitnerium'},
        { family: 2, symbol: 'Ds', label: 'Darmstadtium'},
        { family: 2, symbol: 'Rg', label: 'Roentgenium'},
        { family: 2, symbol: 'Cn', label: 'Copernicium'},
        { family: 3, symbol: 'Al', label: 'Aluminum'},
        { family: 3, symbol: 'Ga', label: 'Gallium'},
        { family: 3, symbol: 'In', label: 'Indium'},
        { family: 3, symbol: 'Sn', label: 'Tin'},
        { family: 3, symbol: 'Tl', label: 'Thallium'},
        { family: 3, symbol: 'Pb', label: 'Lead'},
        { family: 3, symbol: 'Bi', label: 'Bismuth'},
        { family: 3, symbol: 'Nh', label: 'Nihonium'},
        { family: 3, symbol: 'Fl', label: 'Flerovium'},
        { family: 3, symbol: 'Mc', label: 'Moscovium'},
        { family: 3, symbol: 'Lv', label: 'Livermorium'},
        { family: 4, symbol: 'B', label: 'Boron'},
        { family: 4, symbol: 'Si', label: 'Silicon'},
        { family: 4, symbol: 'Ge', label: 'Germanium'},
        { family: 4, symbol: 'As', label: 'Arsenic'},
        { family: 4, symbol: 'Sb', label: 'Antimony'},
        { family: 4, symbol: 'Te', label: 'Tellurium'},
        { family: 4, symbol: 'Po', label: 'Polonium'},
        { family: 5, symbol: 'H', label: 'Hydrogen' },
        { family: 5, symbol: 'C', label: 'Carbon' },
        { family: 5, symbol: 'N', label: 'Nitrogen' },
        { family: 5, symbol: 'O', label: 'Oxygen' },
        { family: 5, symbol: 'F', label: 'Fluorine' },
        { family: 5, symbol: 'P', label: 'Phosphorus' },
        { family: 5, symbol: 'S', label: 'Sulfur' },
        { family: 5, symbol: 'Cl', label: 'Chlorine'},
        { family: 5, symbol: 'Se', label: 'Selenium'},
        { family: 5, symbol: 'Br', label: 'Bromine'},
        { family: 5, symbol: 'I', label: 'Iodine'},
        { family: 5, symbol: 'At', label: 'Astatine'},
        { family: 5, symbol: 'Ts', label: 'Tennessine'},
        { family: 6, symbol: 'He', label: 'Helium'},
        { family: 6, symbol: 'Ne', label: 'Neon'},
        { family: 6, symbol: 'Ar', label: 'Argon'},
        { family: 6, symbol: 'Kr', label: 'Krypton'},
        { family: 6, symbol: 'Xe', label: 'Xenon'},
        { family: 6, symbol: 'Rn', label: 'Radon'},
        { family: 6, symbol: 'Og', label: 'Oganesson'},
        { family: 7, symbol: 'Ce', label: 'Cerium' },
        { family: 7, symbol: 'Pr', label: 'Praseodymium' },
        { family: 7, symbol: 'Nd', label: 'Neodymium' },
        { family: 7, symbol: 'Pm', label: 'Promethium' },
        { family: 7, symbol: 'Sm', label: 'Samarium' },
        { family: 7, symbol: 'Eu', label: 'Europium' },
        { family: 7, symbol: 'Gd', label: 'Gadolinium' },
        { family: 7, symbol: 'Tb', label: 'Terbium' },
        { family: 7, symbol: 'Dy', label: 'Dysprosium' },
        { family: 7, symbol: 'Ho', label: 'Holmium' },
        { family: 7, symbol: 'Er', label: 'Erbium' },
        { family: 7, symbol: 'Tm', label: 'Thulium' },
        { family: 7, symbol: 'Yb', label: 'Ytterbium' },
        { family: 7, symbol: 'Lu', label: 'Lutetium' },
        { family: 8, symbol: 'Th', label: 'Thorium' },
        { family: 8, symbol: 'Pa', label: 'Protactinium' },
        { family: 8, symbol: 'U', label: 'Uranium' },
        { family: 8, symbol: 'Np', label: 'Neptunium' },
        { family: 8, symbol: 'Pu', label: 'Plutonium' },
        { family: 8, symbol: 'Am', label: 'Americium' },
        { family: 8, symbol: 'Cm', label: 'Curium' },
        { family: 8, symbol: 'Bk', label: 'Berkellium' },
        { family: 8, symbol: 'Cf', label: 'Californium' },
        { family: 8, symbol: 'Es', label: 'Einsteinium' },
        { family: 8, symbol: 'Fm', label: 'Fermium' },
        { family: 8, symbol: 'Md', label: 'Mendelevium' },
        { family: 8, symbol: 'No', label: 'Nobelium' },
        { family: 8, symbol: 'Lr', label: 'Lawrencium' }
    ],
    es: [
        { family: 0, symbol: 'Li', label: 'Litio' },
        { family: 0, symbol: 'Na', label: 'Sodio' },
        { family: 0, symbol: 'K', label: 'Potasio' },
        { family: 0, symbol: 'Rb', label: 'Rubidio' },
        { family: 0, symbol: 'Cs', label: 'Cesio' },
        { family: 0, symbol: 'Fr', label: 'Francio' },
        { family: 1, symbol: 'Be', label: 'Berilio' },
        { family: 1, symbol: 'Mg', label: 'Magnesio' },
        { family: 1, symbol: 'Ca', label: 'Calcio' },
        { family: 1, symbol: 'Sr', label: 'Estroncio' },
        { family: 1, symbol: 'Ba', label: 'Bario' },
        { family: 1, symbol: 'Ra', label: 'Radio' },
        { family: 2, symbol: 'Sc', label: 'Escandio'},
        { family: 2, symbol: 'Ti', label: 'Titanio'},
        { family: 2, symbol: 'V', label: 'Vanadio'},
        { family: 2, symbol: 'Cr', label: 'Chromo'},
        { family: 2, symbol: 'Mn', label: 'Manganeso'},
        { family: 2, symbol: 'Fe', label: 'Hierro'},
        { family: 2, symbol: 'Co', label: 'Cobalto'},
        { family: 2, symbol: 'Ni', label: 'Níquel'},
        { family: 2, symbol: 'Cu', label: 'Cobre'},
        { family: 2, symbol: 'Zn', label: 'Zinc'},
        { family: 2, symbol: 'Y', label: 'Itrio'},
        { family: 2, symbol: 'Zr', label: 'Circonio'},
        { family: 2, symbol: 'Nb', label: 'Niobio'},
        { family: 2, symbol: 'Mo', label: 'Molibdeno'},
        { family: 2, symbol: 'Tc', label: 'Tecnecio'},
        { family: 2, symbol: 'Ru', label: 'Rutenio'},
        { family: 2, symbol: 'Rh', label: 'Rodio'},
        { family: 2, symbol: 'Pd', label: 'Paladio'},
        { family: 2, symbol: 'Ag', label: 'Plata'},
        { family: 2, symbol: 'Cd', label: 'Cadmio'},
        { family: 2, symbol: 'La', label: 'Lanthano'},
        { family: 2, symbol: 'Hf', label: 'Hafnio'},
        { family: 2, symbol: 'Ta', label: 'Tantalio'},
        { family: 2, symbol: 'W', label: 'Wolframio'},
        { family: 2, symbol: 'Re', label: 'Renio'},
        { family: 2, symbol: 'Os', label: 'Osmio'},
        { family: 2, symbol: 'Ir', label: 'Iridio'},
        { family: 2, symbol: 'Pt', label: 'Platino'},
        { family: 2, symbol: 'Au', label: 'Oro'},
        { family: 2, symbol: 'Hg', label: 'Mercurio'},
        { family: 2, symbol: 'Ac', label: 'Actinio'},
        { family: 2, symbol: 'Rf', label: 'Rutherfordio'},
        { family: 2, symbol: 'Db', label: 'Dubnio'},
        { family: 2, symbol: 'Sg', label: 'Seaborgio'},
        { family: 2, symbol: 'Bh', label: 'Bohrio'},
        { family: 2, symbol: 'Hs', label: 'Hasio'},
        { family: 2, symbol: 'Mt', label: 'Meitnerio'},
        { family: 2, symbol: 'Ds', label: 'Darmstadtio'},
        { family: 2, symbol: 'Rg', label: 'Roentgenio'},
        { family: 2, symbol: 'Cn', label: 'Copérnico'},
        { family: 3, symbol: 'Al', label: 'Aluminio'},
        { family: 3, symbol: 'Ga', label: 'Galio'},
        { family: 3, symbol: 'In', label: 'Indio'},
        { family: 3, symbol: 'Sn', label: 'Estaño'},
        { family: 3, symbol: 'Tl', label: 'Talio'},
        { family: 3, symbol: 'Pb', label: 'Dirigir'},
        { family: 3, symbol: 'Bi', label: 'Bismuto'},
        { family: 3, symbol: 'Nh', label: 'Nihonio'},
        { family: 3, symbol: 'Fl', label: 'Flerovio'},
        { family: 3, symbol: 'Mc', label: 'Moscovio'},
        { family: 3, symbol: 'Lv', label: 'Hígado'},
        { family: 4, symbol: 'B', label: 'Boro'},
        { family: 4, symbol: 'Si', label: 'Silicio'},
        { family: 4, symbol: 'Ge', label: 'Germanio'},
        { family: 4, symbol: 'As', label: 'Arsénico'},
        { family: 4, symbol: 'Sb', label: 'Antimonio'},
        { family: 4, symbol: 'Te', label: 'Telurio'},
        { family: 4, symbol: 'Po', label: 'Polonio'},
        { family: 5, symbol: 'H', label: 'Hidrógeno' },
        { family: 5, symbol: 'C', label: 'Carbono' },
        { family: 5, symbol: 'N', label: 'Nitrógeno' },
        { family: 5, symbol: 'O', label: 'Oxígeno' },
        { family: 5, symbol: 'F', label: 'Flúor' },
        { family: 5, symbol: 'P', label: 'Fósforo' },
        { family: 5, symbol: 'S', label: 'Azufre' },
        { family: 5, symbol: 'Cl', label: 'Cloro'},
        { family: 5, symbol: 'Se', label: 'Selenio'},
        { family: 5, symbol: 'Br', label: 'Bromo'},
        { family: 5, symbol: 'I', label: 'Yodo'},
        { family: 5, symbol: 'At', label: 'Astato'},
        { family: 5, symbol: 'Ts', label: 'Tennessee'},
        { family: 6, symbol: 'He', label: 'Helio'},
        { family: 6, symbol: 'Ne', label: 'Neón'},
        { family: 6, symbol: 'Ar', label: 'Argón'},
        { family: 6, symbol: 'Kr', label: 'Criptón'},
        { family: 6, symbol: 'Xe', label: 'Xenón'},
        { family: 6, symbol: 'Rn', label: 'Radón'},
        { family: 6, symbol: 'Og', label: 'Oganesson'},
        { family: 7, symbol: 'Ce', label: 'Cerio' },
        { family: 7, symbol: 'Pr', label: 'Praseodimio' },
        { family: 7, symbol: 'Nd', label: 'Neodimio' },
        { family: 7, symbol: 'Pm', label: 'Prometeo' },
        { family: 7, symbol: 'Sm', label: 'Samario' },
        { family: 7, symbol: 'Eu', label: 'Europio' },
        { family: 7, symbol: 'Gd', label: 'Gadolinio' },
        { family: 7, symbol: 'Tb', label: 'Terbio' },
        { family: 7, symbol: 'Dy', label: 'Disprosio' },
        { family: 7, symbol: 'Ho', label: 'Holmio' },
        { family: 7, symbol: 'Er', label: 'Erbio' },
        { family: 7, symbol: 'Tm', label: 'Tulio' },
        { family: 7, symbol: 'Yb', label: 'Iterbio' },
        { family: 7, symbol: 'Lu', label: 'Lutecio' },
        { family: 8, symbol: 'Th', label: 'Torio' },
        { family: 8, symbol: 'Pa', label: 'Protactinio' },
        { family: 8, symbol: 'U', label: 'Uranio' },
        { family: 8, symbol: 'Np', label: 'Neptunio' },
        { family: 8, symbol: 'Pu', label: 'Plutonio' },
        { family: 8, symbol: 'Am', label: 'Americio' },
        { family: 8, symbol: 'Cm', label: 'Curio' },
        { family: 8, symbol: 'Bk', label: 'Berkelio' },
        { family: 8, symbol: 'Cf', label: 'Californium' },
        { family: 8, symbol: 'Es', label: 'Einsteinio' },
        { family: 8, symbol: 'Fm', label: 'Fermio' },
        { family: 8, symbol: 'Md', label: 'Mendelevio' },
        { family: 8, symbol: 'No', label: 'Nobelio' },
        { family: 8, symbol: 'Lr', label: 'Lawrencio' }
    ],
    fr: [
        { family: 0, symbol: 'Li', label: 'Lithium' },
        { family: 0, symbol: 'Na', label: 'Sodium' },
        { family: 0, symbol: 'K', label: 'Potassium' },
        { family: 0, symbol: 'Rb', label: 'Rubidium' },
        { family: 0, symbol: 'Cs', label: 'Césium' },
        { family: 0, symbol: 'Fr', label: 'Francium' },
        { family: 1, symbol: 'Be', label: 'Béryllium' },
        { family: 1, symbol: 'Mg', label: 'Magnésium' },
        { family: 1, symbol: 'Ca', label: 'Calcium' },
        { family: 1, symbol: 'Sr', label: 'Strontium' },
        { family: 1, symbol: 'Ba', label: 'Baryum' },
        { family: 1, symbol: 'Ra', label: 'Radium' },
        { family: 2, symbol: 'Sc', label: 'Scandium'},
        { family: 2, symbol: 'Ti', label: 'Titane'},
        { family: 2, symbol: 'V', label: 'Vanadium'},
        { family: 2, symbol: 'Cr', label: 'Chrome'},
        { family: 2, symbol: 'Mn', label: 'Manganèse'},
        { family: 2, symbol: 'Fe', label: 'Fer'},
        { family: 2, symbol: 'Co', label: 'Cobalt'},
        { family: 2, symbol: 'Ni', label: 'Nickel'},
        { family: 2, symbol: 'Cu', label: 'Cuivre'},
        { family: 2, symbol: 'Zn', label: 'Zinc'},
        { family: 2, symbol: 'Y', label: 'Yttrium'},
        { family: 2, symbol: 'Zr', label: 'Zirconium'},
        { family: 2, symbol: 'Nb', label: 'Niobium'},
        { family: 2, symbol: 'Mo', label: 'Molybdène'},
        { family: 2, symbol: 'Tc', label: 'Technétium'},
        { family: 2, symbol: 'Ru', label: 'Ruthénium'},
        { family: 2, symbol: 'Rh', label: 'Rhodié'},
        { family: 2, symbol: 'Pd', label: 'Palladium'},
        { family: 2, symbol: 'Ag', label: 'Argent'},
        { family: 2, symbol: 'Cd', label: 'Cadmium'},
        { family: 2, symbol: 'La', label: 'Lanthane'},
        { family: 2, symbol: 'Hf', label: 'Hafnium'},
        { family: 2, symbol: 'Ta', label: 'Tantale'},
        { family: 2, symbol: 'W', label: 'Wolfram'},
        { family: 2, symbol: 'Re', label: 'Rhénium'},
        { family: 2, symbol: 'Os', label: 'Osmium'},
        { family: 2, symbol: 'Ir', label: 'Iridium'},
        { family: 2, symbol: 'Pt', label: 'Platine'},
        { family: 2, symbol: 'Au', label: 'Or'},
        { family: 2, symbol: 'Hg', label: 'Mercure'},
        { family: 2, symbol: 'Ac', label: 'Actinium'},
        { family: 2, symbol: 'Rf', label: 'Rutherfordium'},
        { family: 2, symbol: 'Db', label: 'Dubnium'},
        { family: 2, symbol: 'Sg', label: 'Seaborgium'},
        { family: 2, symbol: 'Bh', label: 'Bohrium'},
        { family: 2, symbol: 'Hs', label: 'Hassium'},
        { family: 2, symbol: 'Mt', label: 'Meitnerium'},
        { family: 2, symbol: 'Ds', label: 'Darmstadtium'},
        { family: 2, symbol: 'Rg', label: 'Roentgenium'},
        { family: 2, symbol: 'Cn', label: 'Copernicium'},
        { family: 3, symbol: 'Al', label: 'Aluminum'},
        { family: 3, symbol: 'Ga', label: 'Gallium'},
        { family: 3, symbol: 'In', label: 'Indium'},
        { family: 3, symbol: 'Sn', label: 'Étain'},
        { family: 3, symbol: 'Tl', label: 'Thallium'},
        { family: 3, symbol: 'Pb', label: 'Plomb'},
        { family: 3, symbol: 'Bi', label: 'Bismuth'},
        { family: 3, symbol: 'Nh', label: 'Nihonium'},
        { family: 3, symbol: 'Fl', label: 'Flérovium'},
        { family: 3, symbol: 'Mc', label: 'Moscovie'},
        { family: 3, symbol: 'Lv', label: 'Livermorium'},
        { family: 4, symbol: 'B', label: 'Bore'},
        { family: 4, symbol: 'Si', label: 'Silicium'},
        { family: 4, symbol: 'Ge', label: 'Germanium'},
        { family: 4, symbol: 'As', label: 'Arsenic'},
        { family: 4, symbol: 'Sb', label: 'Antimoine'},
        { family: 4, symbol: 'Te', label: 'Tellure'},
        { family: 4, symbol: 'Po', label: 'Polonium'},
        { family: 5, symbol: 'H', label: 'Hydrogène' },
        { family: 5, symbol: 'C', label: 'Carbone' },
        { family: 5, symbol: 'N', label: 'Azote' },
        { family: 5, symbol: 'O', label: 'Oxygène' },
        { family: 5, symbol: 'F', label: 'Fluor' },
        { family: 5, symbol: 'P', label: 'Phosphore' },
        { family: 5, symbol: 'S', label: 'Sufre' },
        { family: 5, symbol: 'Cl', label: 'Clore'},
        { family: 5, symbol: 'Se', label: 'Sélénium'},
        { family: 5, symbol: 'Br', label: 'Brome'},
        { family: 5, symbol: 'I', label: 'Iode'},
        { family: 5, symbol: 'At', label: 'Astatine'},
        { family: 5, symbol: 'Ts', label: 'Tennessine'},
        { family: 6, symbol: 'He', label: 'Hélium'},
        { family: 6, symbol: 'Ne', label: 'Néon'},
        { family: 6, symbol: 'Ar', label: 'Argon'},
        { family: 6, symbol: 'Kr', label: 'Krypton'},
        { family: 6, symbol: 'Xe', label: 'Xénon'},
        { family: 6, symbol: 'Rn', label: 'Radon'},
        { family: 6, symbol: 'Og', label: 'Oganesson'},
        { family: 7, symbol: 'Ce', label: 'Cérium' },
        { family: 7, symbol: 'Pr', label: 'Praséodyme' },
        { family: 7, symbol: 'Nd', label: 'Néodyme' },
        { family: 7, symbol: 'Pm', label: 'Prométhium' },
        { family: 7, symbol: 'Sm', label: 'Samarium' },
        { family: 7, symbol: 'Eu', label: 'Europium' },
        { family: 7, symbol: 'Gd', label: 'Gadolinium' },
        { family: 7, symbol: 'Tb', label: 'Terbium' },
        { family: 7, symbol: 'Dy', label: 'Dysprosium' },
        { family: 7, symbol: 'Ho', label: 'Holmium' },
        { family: 7, symbol: 'Er', label: 'Erbium' },
        { family: 7, symbol: 'Tm', label: 'Thulium' },
        { family: 7, symbol: 'Yb', label: 'Ytterbium' },
        { family: 7, symbol: 'Lu', label: 'Lutétium' },
        { family: 8, symbol: 'Th', label: 'Thorium' },
        { family: 8, symbol: 'Pa', label: 'Protactinium' },
        { family: 8, symbol: 'U', label: 'Uranium' },
        { family: 8, symbol: 'Np', label: 'Neptunium' },
        { family: 8, symbol: 'Pu', label: 'Plutonium' },
        { family: 8, symbol: 'Am', label: 'Américium' },
        { family: 8, symbol: 'Cm', label: 'Curium' },
        { family: 8, symbol: 'Bk', label: 'Berkélium' },
        { family: 8, symbol: 'Cf', label: 'Californie'},
        { family: 8, symbol: 'Es', label: 'Einsteinium' },
        { family: 8, symbol: 'Fm', label: 'Fermium' },
        { family: 8, symbol: 'Md', label: 'Mendélévion' },
        { family: 8, symbol: 'No', label: 'Nobelium' },
        { family: 8, symbol: 'Lr', label: 'Lawrence' }
    ],
    it: [
        { family: 0, symbol: 'Li', label: 'Litio' },
        { family: 0, symbol: 'Na', label: 'Sodio' },
        { family: 0, symbol: 'K', label: 'Potassio' },
        { family: 0, symbol: 'Rb', label: 'Rubidio' },
        { family: 0, symbol: 'Cs', label: 'Cesio' },
        { family: 0, symbol: 'Fr', label: 'Francio' },
        { family: 1, symbol: 'Be', label: 'Beryllio' },
        { family: 1, symbol: 'Mg', label: 'Magnesio' },
        { family: 1, symbol: 'Ca', label: 'Calcio' },
        { family: 1, symbol: 'Sr', label: 'Stronzio' },
        { family: 1, symbol: 'Ba', label: 'Bario' },
        { family: 1, symbol: 'Ra', label: 'Radio' },
        { family: 2, symbol: 'Sc', label: 'Scandio'},
        { family: 2, symbol: 'Ti', label: 'Titanio'},
        { family: 2, symbol: 'V', label: 'Vanadio'},
        { family: 2, symbol: 'Cr', label: 'Cromo'},
        { family: 2, symbol: 'Mn', label: 'Manganese'},
        { family: 2, symbol: 'Fe', label: 'Ferro'},
        { family: 2, symbol: 'Co', label: 'Cobalto'},
        { family: 2, symbol: 'Ni', label: 'Nichel'},
        { family: 2, symbol: 'Cu', label: 'Rame'},
        { family: 2, symbol: 'Zn', label: 'Zinco'},
        { family: 2, symbol: 'Y', label: 'Ittrio'},
        { family: 2, symbol: 'Zr', label: 'Zirconio'},
        { family: 2, symbol: 'Nb', label: 'Niobio'},
        { family: 2, symbol: 'Mo', label: 'Molibdeno'},
        { family: 2, symbol: 'Tc', label: 'Tecnezio'},
        { family: 2, symbol: 'Ru', label: 'Rutenio'},
        { family: 2, symbol: 'Rh', label: 'Rodio'},
        { family: 2, symbol: 'Pd', label: 'Palladio'},
        { family: 2, symbol: 'Ag', label: 'Argento'},
        { family: 2, symbol: 'Cd', label: 'Cadmio'},
        { family: 2, symbol: 'La', label: 'Lantanio'},
        { family: 2, symbol: 'Hf', label: 'Afnio'},
        { family: 2, symbol: 'Ta', label: 'Tantalio'},
        { family: 2, symbol: 'W', label: 'Wolfram'},
        { family: 2, symbol: 'Re', label: 'Renio'},
        { family: 2, symbol: 'Os', label: 'Osmio'},
        { family: 2, symbol: 'Ir', label: 'Iridio'},
        { family: 2, symbol: 'Pt', label: 'Platino'},
        { family: 2, symbol: 'Au', label: 'Oro'},
        { family: 2, symbol: 'Hg', label: 'Mercurio'},
        { family: 2, symbol: 'Ac', label: 'Attinio'},
        { family: 2, symbol: 'Rf', label: 'Rutherfordio'},
        { family: 2, symbol: 'Db', label: 'Dubio'},
        { family: 2, symbol: 'Sg', label: 'Seaborgio'},
        { family: 2, symbol: 'Bh', label: 'Borrio'},
        { family: 2, symbol: 'Hs', label: 'Hassium'},
        { family: 2, symbol: 'Mt', label: 'Meitnerio'},
        { family: 2, symbol: 'Ds', label: 'Darmstadtio'},
        { family: 2, symbol: 'Rg', label: 'Roentgenio'},
        { family: 2, symbol: 'Cn', label: 'Copernicio'},
        { family: 3, symbol: 'Al', label: 'Aluminum'},
        { family: 3, symbol: 'Ga', label: 'Gallium'},
        { family: 3, symbol: 'In', label: 'Indio'},
        { family: 3, symbol: 'Sn', label: 'Lattina'},
        { family: 3, symbol: 'Tl', label: 'Tallio'},
        { family: 3, symbol: 'Pb', label: 'Guida'},
        { family: 3, symbol: 'Bi', label: 'Bismuto'},
        { family: 3, symbol: 'Nh', label: 'Nihonium'},
        { family: 3, symbol: 'Fl', label: 'Flerovium'},
        { family: 3, symbol: 'Mc', label: 'Mosca'},
        { family: 3, symbol: 'Lv', label: 'Livermorio'},
        { family: 4, symbol: 'B', label: 'Boro'},
        { family: 4, symbol: 'Si', label: 'Silicio'},
        { family: 4, symbol: 'Ge', label: 'Germanio'},
        { family: 4, symbol: 'As', label: 'Arsenico'},
        { family: 4, symbol: 'Sb', label: 'Antimonio'},
        { family: 4, symbol: 'Te', label: 'Tellurio'},
        { family: 4, symbol: 'Po', label: 'Polonio'},
        { family: 5, symbol: 'H', label: 'Idrogeno' },
        { family: 5, symbol: 'C', label: 'Carbonio' },
        { family: 5, symbol: 'N', label: 'Azoto' },
        { family: 5, symbol: 'O', label: 'Ossigeno' },
        { family: 5, symbol: 'F', label: 'Fluoro' },
        { family: 5, symbol: 'P', label: 'Fosforo' },
        { family: 5, symbol: 'S', label: 'Zolfo' },
        { family: 5, symbol: 'Cl', label: 'Cloro'},
        { family: 5, symbol: 'Se', label: 'Selenio'},
        { family: 5, symbol: 'Br', label: 'Bromo'},
        { family: 5, symbol: 'I', label: 'Iodio'},
        { family: 5, symbol: 'At', label: 'Astato'},
        { family: 5, symbol: 'Ts', label: 'Tennessee'},
        { family: 6, symbol: 'He', label: 'Elio'},
        { family: 6, symbol: 'Ne', label: 'Neon'},
        { family: 6, symbol: 'Ar', label: 'Argon'},
        { family: 6, symbol: 'Kr', label: 'Kripton'},
        { family: 6, symbol: 'Xe', label: 'Xeno'},
        { family: 6, symbol: 'Rn', label: 'Radon'},
        { family: 6, symbol: 'Og', label: 'Oganesson'},
        { family: 7, symbol: 'Ce', label: 'Cerio' },
        { family: 7, symbol: 'Pr', label: 'Praseodimio' },
        { family: 7, symbol: 'Nd', label: 'Neodimio' },
        { family: 7, symbol: 'Pm', label: 'Promezio' },
        { family: 7, symbol: 'Sm', label: 'Samario' },
        { family: 7, symbol: 'Eu', label: 'Europio' },
        { family: 7, symbol: 'Gd', label: 'Gadolinio' },
        { family: 7, symbol: 'Tb', label: 'Terbio' },
        { family: 7, symbol: 'Dy', label: 'Disprosio' },
        { family: 7, symbol: 'Ho', label: 'Olmio' },
        { family: 7, symbol: 'Er', label: 'Erbio' },
        { family: 7, symbol: 'Tm', label: 'Tulio' },
        { family: 7, symbol: 'Yb', label: 'Itterbio' },
        { family: 7, symbol: 'Lu', label: 'Lutezio' },
        { family: 8, symbol: 'Th', label: 'Torio' },
        { family: 8, symbol: 'Pa', label: 'Protoattinio' },
        { family: 8, symbol: 'U', label: 'Uranio' },
        { family: 8, symbol: 'Np', label: 'Nettuno' },
        { family: 8, symbol: 'Pu', label: 'Plutonio' },
        { family: 8, symbol: 'Am', label: 'Americio' },
        { family: 8, symbol: 'Cm', label: 'Curio' },
        { family: 8, symbol: 'Bk', label: 'Berkelio' },
        { family: 8, symbol: 'Cf', label: 'Californio' },
        { family: 8, symbol: 'Es', label: 'Einsteinio' },
        { family: 8, symbol: 'Fm', label: 'Fermio' },
        { family: 8, symbol: 'Md', label: 'Mendelevio' },
        { family: 8, symbol: 'No', label: 'Nobelio' },
        { family: 8, symbol: 'Lr', label: 'Lawrence' }
    ],
    ru: [
        { family: 0, symbol: 'Li', label: 'Литий' },
        { family: 0, symbol: 'Na', label: 'Натрий' },
        { family: 0, symbol: 'K', label: 'Калий' },
        { family: 0, symbol: 'Rb', label: 'Рубидий' },
        { family: 0, symbol: 'Cs', label: 'Цезий' },
        { family: 0, symbol: 'Fr', label: 'Франций' },
        { family: 1, symbol: 'Be', label: 'Бериллий' },
        { family: 1, symbol: 'Mg', label: 'Магний' },
        { family: 1, symbol: 'Ca', label: 'Кальций' },
        { family: 1, symbol: 'Sr', label: 'Стронций' },
        { family: 1, symbol: 'Ba', label: 'Барий' },
        { family: 1, symbol: 'Ra', label: 'Радий' },
        { family: 2, symbol: 'Sc', label: 'Скандий'},
        { family: 2, symbol: 'Ti', label: 'Титан'},
        { family: 2, symbol: 'V', label: 'Ванадий'},
        { family: 2, symbol: 'Cr', label: 'Хром'},
        { family: 2, symbol: 'Mn', label: 'Марганец'},
        { family: 2, symbol: 'Fe', label: 'Железо'},
        { family: 2, symbol: 'Co', label: 'Кобальт'},
        { family: 2, symbol: 'Ni', label: 'Никель'},
        { family: 2, symbol: 'Cu', label: 'Медь'},
        { family: 2, symbol: 'Zn', label: 'Медь'},
        { family: 2, symbol: 'Y', label: 'Иттрий'},
        { family: 2, symbol: 'Zr', label: 'Цирконий'},
        { family: 2, symbol: 'Nb', label: 'Ниобий'},
        { family: 2, symbol: 'Mo', label: 'Молибден'},
        { family: 2, symbol: 'Tc', label: 'Технеций'},
        { family: 2, symbol: 'Ru', label: 'Рутений'},
        { family: 2, symbol: 'Rh', label: 'Родий'},
        { family: 2, symbol: 'Pd', label: 'Палладий'},
        { family: 2, symbol: 'Ag', label: 'Серебро'},
        { family: 2, symbol: 'Cd', label: 'Кадмий'},
        { family: 2, symbol: 'La', label: 'Лантан'},
        { family: 2, symbol: 'Hf', label: 'Гафний'},
        { family: 2, symbol: 'Ta', label: 'Тантал'},
        { family: 2, symbol: 'W', label: 'Вольфрам'},
        { family: 2, symbol: 'Re', label: 'Рений'},
        { family: 2, symbol: 'Os', label: 'Осмий'},
        { family: 2, symbol: 'Ir', label: 'Иридий'},
        { family: 2, symbol: 'Pt', label: 'Платина'},
        { family: 2, symbol: 'Au', label: 'Золото'},
        { family: 2, symbol: 'Hg', label: 'Ртуть'},
        { family: 2, symbol: 'Ac', label: 'Актиний'},
        { family: 2, symbol: 'Rf', label: 'Резерфордий'},
        { family: 2, symbol: 'Db', label: 'Дубний'},
        { family: 2, symbol: 'Sg', label: 'Сиборгий'},
        { family: 2, symbol: 'Bh', label: 'Борий'},
        { family: 2, symbol: 'Hs', label: 'Хассий'},
        { family: 2, symbol: 'Mt', label: 'Мейтнерий'},
        { family: 2, symbol: 'Ds', label: 'Дармштадтий'},
        { family: 2, symbol: 'Rg', label: 'Рентгений'},
        { family: 2, symbol: 'Cn', label: 'Коперниций'},
        { family: 3, symbol: 'Al', label: 'Алюминий'},
        { family: 3, symbol: 'Ga', label: 'Галлий'},
        { family: 3, symbol: 'In', label: 'Индий'},
        { family: 3, symbol: 'Sn', label: 'Олово'},
        { family: 3, symbol: 'Tl', label: 'Таллий'},
        { family: 3, symbol: 'Pb', label: 'Свинец'},
        { family: 3, symbol: 'Bi', label: 'Висмут'},
        { family: 3, symbol: 'Nh', label: 'Нихоний'},
        { family: 3, symbol: 'Fl', label: 'Флеровий'},
        { family: 3, symbol: 'Mc', label: 'Московий'},
        { family: 3, symbol: 'Lv', label: 'Ливерморий'},
        { family: 4, symbol: 'B', label: 'Бор'},
        { family: 4, symbol: 'Si', label: 'Кремний'},
        { family: 4, symbol: 'Ge', label: 'Германий'},
        { family: 4, symbol: 'As', label: 'Мышьяк'},
        { family: 4, symbol: 'Sb', label: 'Сурьма'},
        { family: 4, symbol: 'Te', label: 'Теллур'},
        { family: 4, symbol: 'Po', label: 'Полоний'},
        { family: 5, symbol: 'H', label: 'Водород' },
        { family: 5, symbol: 'C', label: 'Углерод' },
        { family: 5, symbol: 'N', label: 'Азот' },
        { family: 5, symbol: 'O', label: 'Кислород' },
        { family: 5, symbol: 'F', label: 'Фтор' },
        { family: 5, symbol: 'P', label: 'Фосфор' },
        { family: 5, symbol: 'S', label: 'Сера' },
        { family: 5, symbol: 'Cl', label: 'Хлор'},
        { family: 5, symbol: 'Se', label: 'Селен'},
        { family: 5, symbol: 'Br', label: 'Бром'},
        { family: 5, symbol: 'I', label: 'Иод'},
        { family: 5, symbol: 'At', label: 'Астат'},
        { family: 5, symbol: 'Ts', label: 'Теннессин'},
        { family: 6, symbol: 'He', label: 'Гелий'},
        { family: 6, symbol: 'Ne', label: 'Неон'},
        { family: 6, symbol: 'Ar', label: 'Аргон'},
        { family: 6, symbol: 'Kr', label: 'Криптон'},
        { family: 6, symbol: 'Xe', label: 'Ксенон'},
        { family: 6, symbol: 'Rn', label: 'Радон'},
        { family: 6, symbol: 'Og', label: 'Оганесон'},
        { family: 7, symbol: 'Ce', label: 'Церий' },
        { family: 7, symbol: 'Pr', label: 'Празеодим' },
        { family: 7, symbol: 'Nd', label: 'Неодим' },
        { family: 7, symbol: 'Pm', label: 'Прометий' },
        { family: 7, symbol: 'Sm', label: 'Самарий' },
        { family: 7, symbol: 'Eu', label: 'Европий' },
        { family: 7, symbol: 'Gd', label: 'Гадолиний' },
        { family: 7, symbol: 'Tb', label: 'Тербий' },
        { family: 7, symbol: 'Dy', label: 'Диспрозий' },
        { family: 7, symbol: 'Ho', label: 'Гольмий' },
        { family: 7, symbol: 'Er', label: 'Эрбий' },
        { family: 7, symbol: 'Tm', label: 'Тулий' },
        { family: 7, symbol: 'Yb', label: 'Иттербий' },
        { family: 7, symbol: 'Lu', label: 'Лютеций' },
        { family: 8, symbol: 'Th', label: 'Торий' },
        { family: 8, symbol: 'Pa', label: 'Протактиний' },
        { family: 8, symbol: 'U', label: 'Уран' },
        { family: 8, symbol: 'Np', label: 'Нептуний' },
        { family: 8, symbol: 'Pu', label: 'Плутоний' },
        { family: 8, symbol: 'Am', label: 'Америций' },
        { family: 8, symbol: 'Cm', label: 'Кюрий' },
        { family: 8, symbol: 'Bk', label: 'Берклий' },
        { family: 8, symbol: 'Cf', label: 'Калифорний' },
        { family: 8, symbol: 'Es', label: 'Эйнштейний' },
        { family: 8, symbol: 'Fm', label: 'Фермий' },
        { family: 8, symbol: 'Md', label: 'Менделевий' },
        { family: 8, symbol: 'No', label: 'Нобелий' },
        { family: 8, symbol: 'Lr', label: 'Лоуренсий' }
    ]
}

export const PERIODIC_TABLE_DATA = {
    ELEMENT_FAMILIES,
    ELEMENTS
};

export default PERIODIC_TABLE_DATA;
